import React from 'react'
import {Flex, Text, Img, useStyleConfig} from '@chakra-ui/react'
import PropTypes from 'prop-types'
import {CutleryIcon, ChronoIcon} from '../../icons'
import useNavigation from '@salesforce/retail-react-app/app/hooks/use-navigation'
import {FormattedMessage} from 'react-intl'

export const RecipeTile = ({title, uid, imageData, difficulty, timeToComplete, gridView}) => {
    const navigate = useNavigation()
    const styles = useStyleConfig('RecipeTile')

    const damImage = imageData
    const handleRecipeSelect = (recipe, e) => {
        if (recipe?.uid && recipe?.uid !== '' && recipe?.title && recipe?.title !== '') {
            const recipeTitle = recipe.title.replace(/[\s']+/g, '-').toLowerCase()
            const recipeUrl = `/r/recipes/${recipeTitle}/${recipe?.uid}`

            //handle open to new tab
            if (e.metaKey || e.ctrlKey || e.button === 1) {
                window.open(recipeUrl, '_blank', 'noopener,noreferrer')
            } else {
                navigate(recipeUrl)
            }
        }
    }
    return (
        <Flex {...styles?.recipeContainer}>
            <Flex
                {...styles?.imageContainer}
                onClick={(e) => handleRecipeSelect({title, uid}, e)}
                onMouseDown={(e) => {
                    if (e.button === 1) handleRecipeSelect({title, uid}, e)
                }}
                cursor="pointer"
            >
                <Img {...styles?.imageObject} src={damImage} alt={title} />
            </Flex>
            <Flex {...styles?.textsContainer}>
                <Text
                    {...styles?.titleText}
                    sx={{
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: 'vertical',
                    }}
                >
                    {title}
                </Text>
                <Flex {...styles?.extraContainer} flexDir={gridView ? 'column' : 'row'}>
                    {difficulty && (
                        <Flex {...styles?.infoContainer}>
                            <CutleryIcon {...styles?.iconConfig} />{' '}
                            <Text {...styles?.infoText}>{difficulty}</Text>
                        </Flex>
                    )}
                    {timeToComplete && (
                        <Flex {...styles?.infoContainer}>
                            <ChronoIcon {...styles?.iconConfig} />{' '}
                            <Text {...styles?.infoText}>
                                {timeToComplete}{' '}
                                <FormattedMessage
                                    id="recipes.listing_page.recipe_tile.time_to_complete_time.text"
                                    defaultMessage="min"
                                />
                            </Text>
                        </Flex>
                    )}
                </Flex>
            </Flex>
        </Flex>
    )
}

RecipeTile.propTypes = {
    title: PropTypes.string,
    uid: PropTypes.string,
    imageData: PropTypes.string,
    difficulty: PropTypes.string,
    timeToComplete: PropTypes.string,
    gridView: PropTypes.bool,
}
